module.exports = __webpack_public_path__ + "static/media/visually-tracking-orders.34c1a0b8.jpg";